import React from 'react'
import AdminNavbar from './AdminNavbar'
import MaterialAdminLayout from './MaterialAdminLayout'
import { Outlet } from 'react-router-dom'
import { Box, Container } from '@mui/material'
import { MATERIAL_ADMIN_BASE, useAdminBasePath } from '../../utils/moduleAccess'

const AdminDashboard = () => {
  // The admin screens are shared. The Material Tracker admin uses the tracker's sidebar layout;
  // Approval Management's admin keeps the top navbar exactly as before.
  if (useAdminBasePath() === MATERIAL_ADMIN_BASE) {
    return <MaterialAdminLayout />
  }

  return (
    <Box>
      <AdminNavbar />
      <Box sx={{px: 7, pt: 4}}>
        <Outlet />
        </Box>
    </Box>
  )
}

export default AdminDashboard
